import React from 'react';
import { type UserSettings, getSettingValue } from '../../services/userSettings';
import ToggleRow from './ToggleRow';

interface NotificationSettingsProps {
    settings: UserSettings;
    onToggle: (key: string) => void;
}

const NotificationSettings: React.FC<NotificationSettingsProps> = ({ settings, onToggle }) => (
    <div className="flex flex-col gap-4">
        <ToggleRow
            label="Chat notifications"
            description="Get an email when ODO posts a new message on a patient's chat."
            checked={getSettingValue(settings, 'notifications', 'chat_activity')}
            disabled={false}
            onChange={() => onToggle('chat_activity')}
        />
        <ToggleRow
            label="Practice digest emails"
            description="Get an email report about patients waiting on you."
            checked={getSettingValue(settings, 'notifications', 'digest_emails')}
            disabled={false}
            onChange={() => onToggle('digest_emails')}
        />
    </div>
);

export default NotificationSettings;
